"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Globe = createSVGIconV2(
  <>
    <circle cx="12" cy="12" r="10.5" stroke="currentColor" />
    <path
      d="M12 1.5C11.9778 1.5 12.0517 1.5015 12.2441 1.63477C12.4172 1.75466 12.6332 1.94412 12.8779 2.20605C13.3658 2.72824 13.9342 3.49935 14.4746 4.46582C15.5561 6.39986 16.5 9.06647 16.5 12C16.5 14.9335 15.5561 17.6001 14.4746 19.5342C13.9342 20.5007 13.3658 21.2718 12.8779 21.7939C12.6332 22.0559 12.4172 22.2453 12.2441 22.3652C12.0517 22.4985 11.9778 22.5 12 22.5C12.0222 22.5 11.9483 22.4985 11.7559 22.3652C11.5828 22.2453 11.3668 22.0559 11.1221 21.7939C10.6342 21.2718 10.0658 20.5007 9.52539 19.5342C8.4439 17.6001 7.5 14.9335 7.5 12C7.5 9.06647 8.4439 6.39986 9.52539 4.46582C10.0658 3.49935 10.6342 2.72824 11.1221 2.20605C11.3668 1.94412 11.5828 1.75466 11.7559 1.63477C11.9483 1.5015 12.0222 1.5 12 1.5Z"
      stroke="currentColor"
    />
    <path
      d="M2 12L22 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  { displayName: "Globe", scalingFactor: 139 / 134 },
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
